export default __webpack_public_path__ + "static/media/marvilop1.216413db.png";